export default __webpack_public_path__ + "static/media/2412305.cbe31efc.webp";